import React from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const ViewStackingReelReprot = ({ stackingReelList, stackingLocation }) => {

    // const exportPDF = () => {
    //     const pdf = new jsPDF('p', 'mm', 'a4');
    //     const margin = 5;
    //     let currentY = margin;
    //     const pageWidth = pdf.internal.pageSize.getWidth();
    //     const tableWidth = 50; // Adjust table width as needed


    //     // Title
    //     pdf.setFontSize(18);
    //     currentY += 4;
    //     pdf.text('STACK WISE AVAILABLE REELS REPORT', margin, currentY);
    //     currentY += 5;

    //     // MO Report Header
    //     pdf.setFontSize(10);
    //     // pdf.text('MO Report', margin, currentY);
    //     // currentY += 4;
    //     pdf.text(`Stacking Location Code # ${stackingLocation}`, margin, currentY);
    //     currentY += 10;



    //     // Combination Details Header
    //     pdf.setFontSize(14);
    //     pdf.text('Available Reels', margin, currentY);
    //     currentY += 5;

    //     pdf.setFontSize(10);
    //     // Table 1 - Combination Details with Subtotals and Grand Total
    //     // const body = [];




    //     currentY = pdf.previousAutoTable.finalY + 10;

    //     // Table Headers for MO Details
    //     autoTable(pdf, {
    //         startY: currentY,
    //         head: [['Stacking Level', 'Reel Code', 'Master Reel', 'Size', 'Quality', 'GSM', 'Diameter', 'Core Dia', 'Reel Weight', 'Customer Code', 'Supplier Code', 'Indent Number', 'Indent Date', 'Line Number', 'MO Number']],
    //         body: stackingReelList.map((detail) => [
    //             detail.stacking_level,
    //             detail.cr_number,
    //             detail.master_reel,
    //             `${detail.d_width} X ${detail.d_length}`,
    //             detail.quality,
    //             detail.gsm,
    //             detail.diameter,
    //             detail.inner_core,
    //             detail.achieved_qty,
    //             detail.customer_name,
    //             detail.supplier_name,
    //             detail.indent_no,
    //             detail.indent_date,
    //             detail.line_no,
    //             detail.mo_number,
    //         ]),
    //         theme: 'grid',
    //         styles: { fontSize: 8, fontFamily: 'cambria' },
    //         headStyles: { fillColor: [61, 73, 162], halign: 'center' },
    //         margin: { left: margin, right: margin },
    //     });

    //     const finalY = pdf.lastAutoTable.finalY || currentY + 10;
    //     currentY = finalY + 10;





    //     pdf.setFontSize(10);
    //     pdf.text('Authorised Signature: ____________________', margin, currentY);

    //     // Save the PDF
    //     pdf.save(`Stacking location # ${stackingLocation} available reel details.pdf`);
    // };


    const formatDate = (dateString) => {
        if (!dateString) return "N/A";  // Handle null or undefined dates
        const date = new Date(dateString);
        
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return "N/A";  // Return "N/A" if the date is invalid
        }
        
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replace(/ /g, "-"); // Replace spaces with hyphens
    };
    const exportPDF = () => {
        const pdf = new jsPDF('landscape', 'mm', 'a4');
        const margin = 5;
        let currentY = margin;

        // Title
        pdf.setFontSize(18);
        currentY += 4;
        pdf.text('STACK WISE AVAILABLE REELS REPORT', margin, currentY);
        currentY += 5;

        // MO Report Header
        pdf.setFontSize(10);
        pdf.text(`Stacking Location Code # ${stackingLocation}`, margin, currentY);
        currentY += 10;

        // Combination Details Header
        pdf.setFontSize(14);
        pdf.text('Available Reels', margin, currentY);
        currentY += 5;

        // Table 1 - Reel Details
        pdf.setFontSize(10);

        autoTable(pdf, {
            startY: currentY,
            head: [['Stacking Level', 'Reel Code', 'Master Reel', 'Size', 'Quality', 'GSM', 'Diameter', 'Core Dia', 'Reel Weight', 'Customer Code', 'Supplier Code', 'Indent Number', 'Indent Date', 'Line Number', 'MO Number']],
            body: stackingReelList.map((detail) => [
                detail.stacking_level,
                detail.cr_number,
                detail.master_reel,
                `${detail.d_width} X ${detail.d_length}`,
                detail.quality,
                detail.gsm,
                detail.diameter,
                detail.inner_core,
                detail.achieved_qty,
                detail.customer_name,
                detail.supplier_name,
                detail.indent_no,
                // detail.indent_date,
                formatDate(detail.indent_date),  // Format the indent_dat
                detail.line_no,
                detail.mo_number,
            ]),
            theme: 'grid',
            styles: { fontSize: 8, fontFamily: 'cambria' },
            headStyles: { fillColor: [61, 73, 162], halign: 'center' },
            margin: { left: margin, right: margin },
        });

        // Move currentY to the next available position after the table
        const finalY = pdf.lastAutoTable.finalY || currentY + 10;
        currentY = finalY + 10;

        // Signature
        pdf.setFontSize(10);
        pdf.text('Authorised Signature: ____________________', margin, currentY);

        // Save the PDF
        pdf.save(`Stacking location # ${stackingLocation} available reel details.pdf`);
    };


    return (
        <div style={{ padding: '20pt', fontFamily: 'cambria', fontSize: '12px', color: 'black', backgroundColor: 'white' }}>
            <h1>STACK WISE AVAILABLE REELS REPORT <button onClick={exportPDF}>Export as PDF</button> </h1>

            {/*  */}
            <div id="report" style={{ padding: '1px', backgroundColor: '#fff', color: '#000' }}>

                <div>
                    <div id="report" style={{ padding: '0px', backgroundColor: '#fff', color: '#000', marginBottom: '10px' }}>
                        {/* <h2>MO Report</h2> */}
                        <p>Stacking Location Code  {stackingLocation}</p>


                        <h3>Available Reels</h3>

                    </div>
                </div>



                <div style={{ width: '100%' }}>


                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '0.2px groove black', padding: '2px' }}>Stacking Level</th>
                                <th style={{ border: '0.2px groove black', padding: '2px' }}>Reel Code</th>
                                <th style={{ border: '0.2px groove black', padding: '2px' }}>Master Reel </th>
                                <th style={{ border: '0.2px groove black', padding: '2px', width: '80px' }}>Size</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Quality</th>
                                <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>GSM</th>
                                <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>Diameter</th>
                                <th style={{ border: '0.2px groove black', padding: '5px', width: '100px' }}>Core Dia</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Reel weight</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Customer Code</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Supplier Code</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Indent Number</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Indent Date</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>Line Number</th>
                                <th style={{ border: '0.2px groove black', padding: '5px' }}>MO Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stackingReelList.map((detail, idx) => (
                                <tr key={idx}>
                                    <td style={{ border: '0.2px groove black', padding: '2px', textAlign: 'center' }}>{detail.stacking_level}</td>
                                    <td style={{ border: '0.2px groove black', padding: '2px', textAlign: 'center' }}>{detail.cr_number}</td>
                                    <td style={{ border: '0.2px groove black', padding: '2px', textAlign: 'center' }}>{detail.master_reel}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'right' }}>{`${detail.d_width} X ${detail.d_length}`}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.quality}</td>
                                    <td style={{ border: '0.2px groove black', padding: '2px', textAlign: 'center' }}>{detail.gsm}</td>
                                    <td style={{ border: '0.2px groove black', padding: '2px', textAlign: 'center' }}>{detail.diameter}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.inner_core}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.achieved_qty}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.customer_name}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.supplier_name}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.indent_no}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{formatDate(detail.indent_date)}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.line_no}</td>
                                    <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{detail.mo_number}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>







            </div>

        </div>

    )
};
export default ViewStackingReelReprot;